<template>
  <span>
    <component
      :is="as"
      v-for="distinction in textids"
      :key="distinction.id"
      v-b-tooltip.hover.noninteractive
      tabindex="0"
      :variant="distinction.variant"
      :title="$t('object:offers.' + distinction.id + '.tooltip')"
      class="clickable-element"
    >
      <i
        v-if="distinction.icon"
        class="icon"
      ><component :is="distinction.icon" /></i>
      {{ $t('object:offers.' + distinction.id + '.badge') }}
    </component>
  </span>
</template>
<script>
import { VBTooltip, BBadge } from 'bootstrap-vue';
import 'scss/bootstrap/vue/components/tooltip.scss';

import IconAwardSolid from 'ICON:IconAwardSolid';
import IconThumbsUpAlternative from 'ICON:IconThumbsUpAlternative';
import IconEnvelope from 'ICON:IconEnvelope';

import IconGift from 'ICON:IconGift';
import config from 'config/appConfig';

export default {
  name: 'SearchOffer',
  components: {
    BBadge,
    IconAwardSolid,
    IconThumbsUpAlternative,
    IconGift,
    IconEnvelope,
  },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    // offer ids to this object
    ids: {
      type: Array,
      default: () => [],
    },
    as: {
      type: String,
      default: 'b-badge',
    },
  },
  data() {
    return {
      distributionArray: config.offerList.distinctions,
    };
  },
  i18nOptions: { namespaces: 'object' },
  computed: {
    textids() {
      // filters the object by id and looks only for ids that are also in this.ids then checks which of the
      // objects in distinctions has the ignore key, and throws the ignored one out. splice used because only three badges should be displayed

      const dateCheck = (offer) => { // EDMT-5268 check if dates set and remove, those offers are rendered by InfoLabel.vue
        if (offer.from) {
          return false;
        }
        return true;
      };
      return this.distributionArray
        .filter((el) => dateCheck(el)) // offers with dates are shown as infolabel, ignore ids
        .filter((el) => this.ids.includes(el.id))
        .filter((el) => !this.distributionArray.map((el2) => el2.ignore).includes(el.id))
        .splice(0, 3);
    },
  },
};
</script>
